import React from 'react';
import { Badge } from '.';
import { useEssentials } from '../../contexts/essentials-context';
import { Box, Text } from '@wix/design-system';
import s from './badge-tooltip.module.scss';

interface BetaBadgeProps {
  // Accepted for API compatibility with the other badges, but BETA is always
  // outlined so it relies on its own neutral stroke and ignores the extra ring.
  showBorder?: boolean;
  appName: string;
  size?: 'tiny' | 'small' | 'medium';
}

export function BetaBadge({ appName, size = 'small' }: BetaBadgeProps) {
  const { t } = useEssentials();

  return (
    <Badge
      skin="neutral"
      type="outlined"
      dataHook="beta-badge"
      uppercase={false}
      size={size}
      tooltipContent={
        <Box direction="vertical" gap="6px">
          <Text
            size="small"
            weight="thin"
            // @ts-expect-error wds types are incompatible
            skin="light"
            className={s.tooltipText}
          >
            {t('beta.badge.tooltip', { appName })}
          </Text>
        </Box>
      }
    >
      <Box>{t('beta.badge')}</Box>
    </Badge>
  );
}
